/**
 * Detect if rendering from the client or the server
 */
export var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);